import { create, StateCreator } from 'zustand';
import { persist } from 'zustand/middleware';

type AutoRefreshEntity = {
  interval: number;
  isLoading: boolean;
};

type AutoRefreshState = {
  entities: Record<string, AutoRefreshEntity>;
};

type AutoRefreshActions = {
  enable: (cacheName: string, intervalInSeconds?: number) => void;
  setLoading: (cacheName: string, isLoading: boolean) => void;
  disable: (cacheName: string) => void;
};

const autoRefreshSlice: StateCreator<AutoRefreshState & AutoRefreshActions> = set => ({
  // Initial state
  entities: {},

  // Actions
  enable: (cacheName: string, intervalInSeconds?: number) =>
    set(state => ({
      entities: {
        ...state.entities,
        [cacheName]: { interval: intervalInSeconds ?? 10e3, isLoading: false },
      },
    })),

  setLoading: (cacheName: string, isLoading: boolean) =>
    set(state => ({
      entities: { ...state.entities, [cacheName]: { ...state.entities[cacheName], isLoading } },
    })),

  disable: (cacheName: string) =>
    set(state => ({
      entities: { ...state.entities, [cacheName]: { interval: 0, isLoading: false } },
    })),
});

const persistedAutoRefreshStore = persist<AutoRefreshState & AutoRefreshActions>(autoRefreshSlice, {
  name: `${window.location.origin}/auto-refresh`,
});

export const useAutoRefreshStore = create(persistedAutoRefreshStore);
